// src/app/dashboard/target-chart/target-chart.component.ts

import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AgChartOptions } from 'ag-charts-community';
import { AgCharts } from "ag-charts-angular";
import { getData } from './targetData';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
 
@Component({
  selector: 'app-target-chart',
  imports: [AgCharts, MatSelectModule, MatInputModule, MatFormFieldModule, MatIconModule, CommonModule, FormsModule],
  templateUrl: './target-chart.component.html',
})
export class TargetChartComponent {
 
  [x: string]: any;
  options!: AgChartOptions; // Use definite assignment operator
  isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    
   
       this.isBrowser = isPlatformBrowser(this.platformId);

    // ✅ Only initialize chart in browser, not during SSR
    if (this.isBrowser) {
      this.options = this.getBarOptions();
    }
    
  }

  getBarOptions(): AgChartOptions {
    return {
      data: getData(),
      series: [
        {
          type: "bar",
          xKey: "quarter",
          yKey: "Target",
          yName: "Target",
          fill: "#d16f32", // Blue
        },
        {
          type: "bar",
          xKey: "quarter",
          yKey: "Achieved",
          yName: "Achieved",
          fill: "#28a745", // Green
        }
      ],
      // title: {
      //   // text: "Target vs Achieved per District",
      //   fontSize: 16,
      // },
      legend: {
        position: "bottom",
      },
      background: {
        fill: "rgba(0, 0, 0, 0)",
      },
      // axes: [
      //   {
      //     type: "category",
      //     position: "bottom",
      //     title: {
      //       text: "District",
      //     },
      //   },
      //   {
      //     type: "number",
      //     position: "left",
      //     title: {
      //       text: "Value",
      //     },
      //   },
      // ],
    };
  }


  
}
